// Copyright (c) Microsoft. All rights reserved.

import { IArchiveSources } from '../../../libs/models/ArchiveSources';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import { IChatUser } from '../../../libs/models/ChatUser';

export interface ChatState {
    id: string;
    title: string;
    memoryBalance: number;
    users: IChatUser[];
    messages: IChatMessage[];
    botProfilePicture: string;
    lastUpdatedTimestamp?: number;
    input: string;
    botResponseStatus: string | undefined;
    userDataLoaded: boolean;
    importingDocuments?: string[];
    chatScope?: ChatScope;
    selectedSources?: IArchiveSources[];
    isHidden?: boolean;
    recentAutoRename?: boolean;
}

export enum ChatScope {
    None,
    Web,
    RecommendedSites,
    SharePoint,
    Archive,
    DocumentUpload, // Same as None, but with a different title
}
